// RoleList.js
import { useState, useEffect } from "react";
import List from "../../../common/list";
import { TextInput } from "../../../common/fields";
import { Button } from "primereact/button";
import useRecipientSelection from "./useRecipientSelection";

const CohortList = ({
  cohorts = [],
  totalCountAud = 0,
  query,
  setQuery,
  fetchCohorts,
  selectedCohorts,
  setSelectedCohorts,
  preSelectedIds = [],
  onSave,
  onCancel,
}) => {
  // The search the dialog's rows were last loaded with ("" before any).
  const storedSearch = typeof query?.search === "string" ? query.search : "";
  const [searchTerm, setSearchTerm] = useState(storedSearch);
  const [filteredCohorts, setFilteredCohorts] = useState(cohorts);



  // Update filteredRoles when roles change or search term changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredCohorts(cohorts);
    } else {
      const filtered = cohorts.filter((r) =>
        r.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCohorts(filtered);
    }
  }, [cohorts, searchTerm]);

  const onSelectionChange = useRecipientSelection({
    rows: filteredCohorts,
    preSelectedIds,
    selected: selectedCohorts,
    setSelected: setSelectedCohorts,
  });

  // Debounced search (like UserList example). Nothing is sent when the
  // dialog opens: the cohorts were loaded with the form.
  useEffect(() => {
    const timer = setTimeout(() => {
      if (storedSearch !== searchTerm) {
        setQuery({ ...query, search: searchTerm, pageNo: 1 });
        fetchCohorts?.(searchTerm);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm, fetchCohorts, setQuery, storedSearch]);

  const handlePageChange = (pageData) => {
    if (query.pageSize !== pageData.rows || query.pageNo !== pageData.page + 1) {
      setQuery({ ...query, pageNo: pageData.page + 1, pageSize: pageData.rows });
    }
  };

  return (
    <div>
      <div className="edexlms-search-filter-bar mb-4 flex">
        <TextInput
          icon="pi pi-search"
          placeholder="Search Cohorts"
          input={{ value: searchTerm, onChange: (e) => setSearchTerm(e.target.value) }}
        />
      </div>

      <List
        data={filteredCohorts}
        totalRecords={totalCountAud}
        pageQuery={query}
        handlePageChange={handlePageChange}
        selectionMode="checkbox"
        selectedRecords={selectedCohorts}
        onSelectionChange={onSelectionChange}
        columns={[
          {
            field: "name",
            header: "Name",
            body: (rowData) => <div>{rowData.name}</div>,
          },
          {
            field: "userCount",
            header: "User Count",
            body: (rowData) => <div>{rowData.userCount ?? 0}</div>,
          },
        ]}
      />

      <div className="flex justify-end mt-4 gap-2">
        <Button label="Cancel" onClick={onCancel} className="p-button-text" />
        <Button label="Save" onClick={() => onSave(selectedCohorts)} />
      </div>
    </div>
  );
};

export default CohortList;
